import { ComingSoon, CS_ICONS } from '../components/ComingSoon.js';

/** Billing surface — a "Coming Soon" stub, matching the V27 mockup. Charge/payment
 *  data still lives in the backend (contact drawer Billing tab surfaces balances). */
export function BillingTab() {
  return (
    <ComingSoon
      icon={CS_ICONS.billing}
      title="Billing — Coming Soon"
      body="Billing module coming soon. Your Chargemaster data will appear here."
    />
  );
}
